import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _, { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import JSONViewer from 'modules/common/components/JSONViewer';
import VisibilityIcon from '@material-ui/icons/Visibility';
import * as actions from '../actions';
import * as c from '../constant';

function ViewLogs({ id, getLogs, logs }) {
  const setModal = useContext(ModalContext);
  const [payload, setPayload] = useState(null);

  useEffect(() => {
    getLogs(id);

    return () => {
      setPayload(null);
    };
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const sortObjectAlphabetically = (obj) => {
    if (typeof obj !== 'object' || obj === null) {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map(sortObjectAlphabetically);
    }

    return Object.keys(obj)
      .sort()
      .reduce((acc, key) => {
        acc[key] = sortObjectAlphabetically(obj[key]);
        return acc;
      }, {});
  };

  const handleViewPayload = (rawPayload) => {
    const sortedPayload = sortObjectAlphabetically(rawPayload || {});
    setPayload(sortedPayload);
  };

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12">
          {payload ? (
            <>
              <button
                type="button"
                onClick={() => setPayload(null)}
                className="btn btn-dark font-weight-bold mr-2"
              >
                Back
              </button>
              {isEmpty(payload) ? (
                <div className="p-3 text-center font-weight-bold text-muted">
                  No Data Found.
                </div>
              ) : (
                <JSONViewer data={payload} rootLabel="Payload" />
              )}
            </>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped table-sm table-bordered table-hover">
                <thead className="table-header">
                  <tr>
                    <th>USER TYPE</th>
                    <th>NAME</th>
                    <th>ACTION</th>
                    <th>DATE</th>
                    <th>PAYLOAD</th>
                  </tr>
                </thead>
                <tbody className="table-details">
                  {logs.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{_.get(item, 'attributes.user_type') || '---'}</td>
                        <td>{_.get(item, 'attributes.user_name') || '---'}</td>
                        <td>{_.get(item, 'attributes.event') || '---'}</td>
                        <td>{_.get(item, 'attributes.created_at') || '---'}</td>
                        <td>
                          <button
                            type="button"
                            onClick={() =>
                              handleViewPayload(
                                _.get(item, 'attributes.payload')
                              )
                            }
                            className="btn btn-sm btn-primary"
                          >
                            <VisibilityIcon />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button
          type="button"
          onClick={closeModal}
          className="btn btn-danger font-weight-bold"
        >
          Close
        </button>
      </div>
    </Modal.Body>
  );
}

ViewLogs.propTypes = {
  id: PropTypes.instanceOf(Number).isRequired,
  getLogs: PropTypes.instanceOf(Function).isRequired,
  logs: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  logs: _.get(api, `${c.GET_LOGS}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(ViewLogs);
